// client/src/utils/sanitize.js

import DOMPurify from 'dompurify';

/**
 * Désinfecte une chaîne pour n’en conserver que le texte brut.
 * Trim, suppression des caractères de contrôle et suppression de toute
 * balise/attribut/script via DOMPurify.
 *
 * @param {any} input Chaîne potentiellement malveillante
 * @returns {string} Chaîne nettoyée
 */
export function sanitize(input) {
  // 1) Ne traiter que les strings
  if (typeof input !== 'string') {
    return '';
  }

  // 2) Couper espaces début/fin
  let clean = input.trim();

  // 3) Supprimer tous les caractères de contrôle Unicode (\p{Cc})
  clean = clean.replace(/\p{Cc}/gu, '');

  // 4) Passer dans DOMPurify avec tags/attrs interdits
  return DOMPurify.sanitize(clean, {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: []
  });
}
